<template>
  <div id="home">
    <v-app>
      <Header parameter="Home" />
      <div id="presentation" class="ed-background">
        <FirstBackground />
      </div>
      <div id="projects" class="mb-4 project-mt">
        <Projects />
      </div>
      <div id="blogs" class="my-4">
        <Blogs />
      </div>
      <div id="experience" class="my-4">
        <Timeline />
      </div>
      <div class="background-section">
        <div id="certifications" class="my-4">
          <Certifications />
        </div>
        <div id="testimonials" class="my-4">
          <Testimonials />
        </div>
      </div>
      <div id="footer">
        <Footer />
      </div>
    </v-app>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from "@/components/Header.vue";
import Timeline from "@/components/Timeline.vue";
import Certifications from "@/components/Certifications.vue";
// import Skills from "@/components/Skills.vue";
import Projects from "@/components/Projects.vue";
import Testimonials from "@/components/Testimonials.vue";
// import Contact from "@/components/Contact.vue";
import FirstBackground from "@/components/FirstBackground.vue";
import Blogs from "@/components/Blogs.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: "Home",
  components: {
    Header,
    Timeline,
    Certifications,
    // Skills,
    Projects,
    Testimonials,
    // Contact,
    FirstBackground,
    Blogs,
    Footer
  }
};
</script>

<style>
/* Importing testing boundary classes */
@import "../assets/css/test.css";
@import "../assets/css/general.css";
@import "../assets/css/responsive.css";

/* 
  https://personal-website-assets104410-dev.s3.amazonaws.com/others/testing/bottom_part.png  
  https://personal-website-assets104410-dev.s3.amazonaws.com/others/testing/edgardos_picture.png 
*/

/* Custom CSS from screen */
.ed-background {
  background-image: url("https://s3.amazonaws.com/personal-website-assets104410-dev/others/edgardo_reinoso.jpg");
  background-position: 52% 52%;
  background-repeat: no-repeat;
  border-bottom-left-radius: 50% 20%;
  border-bottom-right-radius: 50% 20%;
  background-size: cover;
  height: 700px;
}

.curved-background {
  background-image: url("https://personal-website-assets104410-dev.s3.amazonaws.com/others/bottom_part.png");
  background-size: cover;
}

.background-section {
  background-image: url("https://personal-website-assets104410-dev.s3.amazonaws.com/others/gray-right.svg");
  background-size: cover;
}

.carousel-background {
  background-color: #f5f5f5;
}
</style>